import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { getAssociatedTemplate } from "../../utils";
export function StoryNotImplemented() {
  return /*#__PURE__*/React.createElement("div", {
    "data-comment": "Story Template Not Implemented"
  });
}
export function CollectionNotImplemented() {
  return /*#__PURE__*/React.createElement("div", {
    "data-comment": "Collection Template Not Implemented"
  });
}
export function renderCollectionItem(collectionItem, index, collectionTemplates, storyTemplates) {
  var otherProps = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  switch (collectionItem.type) {
    case "collection":
      return /*#__PURE__*/React.createElement(collectionTemplates(getAssociatedTemplate(collectionItem), index), _objectSpread({
        key: "".concat(index, "-").concat(collectionItem.id),
        index: index,
        collection: collectionItem,
        metadata: collectionItem["associated-metadata"] || {}
      }, otherProps));

    case "story":
      return /*#__PURE__*/React.createElement(storyTemplates(index), _objectSpread({
        key: "".concat(index, "-").concat(collectionItem.id),
        index: index,
        story: collectionItem.story,
        metadata: collectionItem["associated-metadata"] || {}
      }, otherProps));

    default:
      return /*#__PURE__*/React.createElement("div", {
        "data-comment": "".concat(collectionItem.type, " not implemented")
      });
  }
}